import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LINKS } from "../../../../../../constants";

const FooterBar: React.FC = () => {
  const { t: translate } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        background: "linear-gradient(180deg, rgba(255,255,255,0) 0%, #FFFFFF 32%)",
        py: { xs: 3, md: 4 },
        mt: { xs: 2, md: 3 },
        zIndex: 2,
      }}
    >
      <Stack direction="row" spacing={2}>
        <Typography
          color="#465869"
          fontSize="12px"
          fontWeight={500}
          fontFamily="Manrope"
          aria-label="title"
        >
          {translate("shipeezi")}
        </Typography>
        <Typography
          color="#465869"
          fontSize="12px"
          fontWeight={500}
          fontFamily="Manrope"
          data-cy="redirectContactForm"
          onClick={() => window.open(LINKS.contact, "_blank")}
          sx={{ cursor: "pointer" }}
        >
          {translate("contact")}
        </Typography>
        <Typography
          color="#465869"
          fontSize="12px"
          fontWeight={500}
          fontFamily="Manrope"
          data-cy="redirectToTermsOfUse"
          onClick={() => window.open(LINKS.termsOfUse, "_blank")}
          sx={{ cursor: "pointer" }}
        >
          {translate("termsOfUse")}
        </Typography>
        <Typography
          color="#465869"
          fontSize="12px"
          fontWeight={500}
          fontFamily="Manrope"
          data-cy="redirectToPrivacyPolicy"
          onClick={() => window.open(LINKS.privacyPolicy, "_blank")}
          sx={{ cursor: "pointer" }}
        >
          {translate("privacyPolicy")}
        </Typography>
      </Stack>
    </Box>
  );
};

export default React.memo(FooterBar);
